import type { FaireProductEntity } from "../../entity_types/product";

export const p_nh7ryrr8jb: FaireProductEntity = {
  token: "p_nh7ryrr8jb",
  type: "product",
  name: "Mahjong Martini Needlepoint Design",
  brandToken: "b_7vceaox2",
  brandName: "Blue Poppy Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/877da45d17d7ca4802a0646291ebfcb719c9f8cf26208ba045515dca5739b6a0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbc99c3a9dc1a22c2e4c9161c3753902776b37f6771d603424ccacfc5c211693.jpeg",
    "https://cdn.faire.com/fastly/bc29ff92f38e2cc4a1ba1ddd7bf8373908b4c875135440c5c78ed5d1f348c9e4.jpeg",
    "https://cdn.faire.com/fastly/160a90003a047912abca3df9af39a44b7396fcc28017b70edfb768a8a8eb695f.jpeg",
    "https://cdn.faire.com/fastly/f39309e525556ef7651de51e4b7a683f2db02657910f678b445d890c959607d9.jpeg",
    "https://cdn.faire.com/fastly/34798b3d30ce60cbe3efb21e5139de69bf1fbb0fc5baa3db1d6c56b5e3ea6fbb.jpeg",
    "https://cdn.faire.com/fastly/a5856714d5aa9539c825d18467798f5e64d4a1b3a0afb906722a29c2b92395de.jpeg",
  ],
  priceDollars: 35,
  description:
    'Our beginner friendly needlepoint kit contains everything needed to start your needlepoint journey:\n\n- 6" x 4” printed art (on an 8’’ x 8’’ size 13 canvas). Our edge-taped canvas does not need stretcher bars\n\n- All of the cotton thread needed to complete the project.\n\n- size-20 needle (quantity two)\n\n- needle threader \n\n- TSA compliant travel scissors\n\n- Blue Poppy Designs re-sealable zip top project bag\n\n- a small 2"x2" piece of sample canvas to practice your stitching\n\n- for the beginner, instructions are included on: How To Needlepoint with the Continental Stitch \n\nThese kits come with retail worthy packaging, and are perfect to put on display.\n\nAll needlepoint kits are made (from start to finish) by me in my artist studio in Savannah, Georgia.',
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:47.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
